import * as React from "react";

export function CloseIcon() {
  return (
    <svg width="7" height="7" fill="none" xmlns="http://www.w3.org/2000/svg">
      <path
        stroke="#000"
        strokeWidth="1.2"
        strokeLinecap="round"
        d="M1.182 5.99L5.99 1.182m0 4.95L1.182 1.323"
      ></path>
    </svg>
  );
}

export default CloseIcon;
